module.exports = __webpack_public_path__ + "static/media/twinkle-color-03.46589901.jpg";